export const DASHBOARD = '/'
export const LOGIN = '/login'
// THEMES
export const THEMES = '/themes'
export const THEME_DETAIL = '/themes/:themeId'
export const ADD_THEME = '/theme-new'
// HOOKS
export const HOOKS = '/hooks'
export const HOOK_DETAIL = '/hooks/:hookId'
export const ADD_HOOK = '/hook-new'
// FLOWS
export const FLOWS = '/flows'
export const FLOW_DETAIL = '/flows/:flowId'
export const ADD_FLOW = '/flow-new'
// PROFILES
export const PROFILES = '/profiles'
export const ADD_PROFILE = '/profiles/new'
export const EDIT_PROFILE = '/profiles/:profileId'
// OTHERS
export const PAYMENT_TEMPLATES = '/payment_templates'
export const STATS = '/stats'
export const USER_CHATS = '/userchats'
